
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assessments",
      function () {
        return require("private-next-pages/assessments/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assessments"])
      });
    }
  